// animCache — persistent client-side cache for per-clip animation GLBs.
//
// A thin instance of the shared Cache-Storage factory (assetCache.js). Animation
// GLBs are smaller than splats but numerous (dozens per character) and re-fetched
// on every reload, so this instance caps the bucket at maxEntries to bound disk
// use and consumes bytes as ArrayBuffers (GLTFLoader.parse, no blob round-trip).
//
// Keyed by URL + version (animation_assets updatedAt, or the asset id as a stable
// fallback). See assetCache.js for the full rationale and best-effort semantics.

import { createAssetCache } from './assetCache.js'
import { glbTruncationReason } from './glbIntegrity.js'

export const animCache = createAssetCache({
  cacheName: 'aos-anim-v1',
  verParam: '__animver',
  maxEntries: 300,
  label: 'animCache',
  // A GLB declares its own total length in its header, so an entry truncated by
  // an interrupted download is detectable here with no server metadata at all.
  // This is the READ side, and it is what makes an already-poisoned cache
  // self-heal: the bucket is cache-first, so short of the AppMenu "Clear Cache"
  // button nothing else could ever dislodge a bad entry. (The bucket name is
  // deliberately NOT bumped to v2 — that would throw away every user's good
  // clips to purge the rare bad one; this evicts exactly the bad ones.)
  // Face clips (ARKit JSON) and kimodo tracks payloads share this bucket and
  // pass through untouched — the check only applies to bytes that are a GLB.
  verify: glbTruncationReason,
})

if (typeof window !== 'undefined') {
  window.__ANIM_CACHE__ = animCache
}
